import { useEffect } from "react";
import { useSelector } from "react-redux";

// import ButtonBack from "../../../../components/Buttons/Back";

const ThankYouPageConfigurador = () => {
  const configuradorObj = useSelector((state) => state.configurador);

  useEffect(() => {
    document.title = "Gracias - Configurador";
    window.scrollTo(0, 0);
  }, []);

  if (configuradorObj.modelinfo === null)
    return <h1 className="text-center p-5">Sin informacion del modelo</h1>;

  return (
    <main className="container configurador">
      <section className="w-100 position-relative">
        <h2
          className="position-absolute bg-white px-1 configurador-float-title"
        >
          Adquiere ya tu nuevo Audi
        </h2>
        <img
          className="w-100"
          style={{ maxHeight: "60vh", objectFit: "contain" }}
          src={configuradorObj?.modelinfo?.media?.url}
          alt="Configurador"
        />
      </section>
      {/* <section className="w-100 ps-2 ps-md-5 ">
        <ButtonBack pagesToBack={2}></ButtonBack>
      </section> */}
      <section className="mt-5 text-center">
        <h1>Gracias por contactarnos</h1>
      </section>
      <section className="mt-3 mt-md-5 text-center">
        <h2>Estamos procesando tu solicitud para brindarte información de tu próximo:</h2>
        <h1>{configuradorObj?.modelinfo?.carline?.name}</h1>
        <span>{configuradorObj?.modelinfo?.model?.name}</span>
        <p className="mt-5 pt-1">Para tu comodidad y seguridad, te informamos que nos estaremos comunicando desde el número: <strong>222 179 1156</strong>, esto con la finalidad de dar seguimiento a tu solicitud y atenderte como lo mereces.</p>
      </section>
      <section className="mt-5 text-center">
        <button
          className={`button-enviar`}
          onClick={() =>
            (window.location = "https://www.audi.com.mx/mx/web/es.html")
          }
        >
          Ir al Home
        </button>
      </section>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((_, i) => {
        return <br key={i}></br>;
      })}
    </main>
  );
};

export default ThankYouPageConfigurador;
